import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavIconService } from '../../Layout/Services/NavIcon.service';
import { faExternalLink, faChartArea, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { navList } from '../../../constants/constants';
import { INav } from '../../Layout/Interfaces/INavigation';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
   public  dashboardItems: any[] = navList;

  constructor(
      private router : Router,
      private navIconService: NavIconService) {
     
    }

  ngOnInit(): void {
    
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

    // Get first row items (Dashboard + first 2 social media)
  getFirstRowItems(): INav[] {
    return this.dashboardItems.slice(0, 3); //Facebook, Instagram
  }

  // Get second row items (remaining 3 social media)
  getSecondRowItems(): INav[] {
    return this.dashboardItems.slice(3, 6); // TikTok, X, YouTube, Reddit
  }

  getIcon(iconName: string): IconDefinition {
    return this.navIconService.getIcon(iconName);
  }

  getBrandColor(navigation: string): string {
    const colors: { [key: string]: string } = {
      'dashboard': '#1890ff',
      'facebook-posts': '#1877f2',
      'instagram-posts': '#e4405f',
      'tiktok-posts': '#000000',
      'twitter-posts': '#1da1f2',
      'youtube-videos': '#ff0000',
      'reddit-submissions': '#ff4500'
    };
    return colors[navigation] || '#1890ff';
  }
}
